import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { LeadForm, Lead } from '../model/model.lead';
import { MAT_DIALOG_DATA, MatSnackBar, MatDialogRef, MatDialog } from '@angular/material';
import { LeadService } from '../lead.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-singlelead',
  templateUrl: './singlelead.component.html',
  styleUrls: ['./singlelead.component.css']
})
export class SingleleadComponent implements OnInit {

  public leadfileds: any;
  public LeadForm: LeadForm;
  public form: FormBuilder;
  campaignid: number;
  public leadForm: any = new LeadForm(null);
  public stateList = [];

  formdata: any = {}
  leadF: any = {}
  dL: any[] = []
  id_state: string = ""
  IsUpdate: number = 0
  uT: string = ""

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<Lead>, protected router: Router, protected msg: MatSnackBar, protected fb: FormBuilder, private leadService: LeadService) {
    console.log(data);
  }

  ngOnInit() {
    console.log("this.data::", this.data)

    if (this.data) {
      this.IsUpdate = typeof this.data.is_update != 'undefined' ? this.data.is_update : 0
      this.uT = this.IsUpdate ? "Edit Lead" : "Add Single Lead"

      // @dialer mapping
      if (sessionStorage.getItem("allcampaign"))
        this.dL = JSON.parse(sessionStorage.getItem("allcampaign"))

      // It will load state
      this.id_state = this.data.id_state

      // It will filter lead field's dialer
      // with agent' selected dialers
      if (this.data.type == 0) {
        let I: any = this.data.leadFields.RawHeader.findIndex((ele: any) => {
          return ele.fields == 'state'
        })
        this.data.leadFields.RawHeader.splice(I, 1)
        this.data.leadFields.RawHeader.forEach((ele: any) => {
          ele[ele.fields] = ""
        })
      }

      // It will merger left dialer's with edit dialer's fields
      // let oFD: any = this.data.leadFields.Dialers,
      //   sIds: any[] = []
      // this.data.leadFields.Dialers.forEach((ele: any) => {
      //   let I: any = this.data.rawFields.Dialers.findIndex((ele2: any) => {
      //     return ele2.id_dialer == ele.id_dialer
      //   })
      //   if (I > -1)
      //     sIds.push(I)
      // })
      // // It will append form key for edit operation
      // for (let i = 0; i < this.data.rawFields.Dialers.length; i++) {
      //   if (sIds.includes(i) == false) {
      //     this.data.rawFields.Dialers[i].forEach((ele3: any) => {
      //       ele3[ele3.fields] = ""
      //     })
      //     oFD.push(this.data.rawFields.Dialers[i])
      //   }
      // }
      // console.log("oFD::", oFD)
      // this.data.leadFields.Dialers = oFD

      // It will filter dialer on agent selection
      let nD: any[] = []
      this.data.leadFields.Dialers.forEach((ele: any) => {
        if (this.data.ActDialers.includes(ele.id_dialer))
          nD.push(ele)
      })
      this.data.leadFields.Dialers = nD

      for (let x1 of this.data.leadFields.Dialers) {
        let iD: any = this.dL.findIndex((ele: any) => {
          return ele.id == x1.id_dialer
        })
        x1['dialer'] = iD > -1 ? this.dL[iD].name : ""
        if (this.data.type == 0)
          x1.header.forEach((ele: any) => {
            ele[ele.fields] = ""
          })
      }

      // It will load form fields
      this.leadF = this.data.leadFields
      this.stateList = this.data.stateList
      console.log(this.leadF)

      // this.formdata = this.data.formdata || null
      // if (this.formdata != null) {
      //   this.leadForm = new LeadForm(this.formdata.value);
      // } else {
      //   this.leadForm = new LeadForm(null);
      // }
      // this.campaignid = this.data.campaign;
      // this.leadForm.assign_date = this.current_datetime();
      // this.leadForm.dispodate = this.current_datetime();
      // this.leadForm.created_date = this.current_datetime();
      // this.form = this.leadForm.makeform(this.fb);
      // console.log(this.form);
    }
  }

  AddsingleLead() {
    console.log("leadFields::", this.leadF)
    this.mapClose({
      leadFields: this.leadF,
      id_state: this.id_state,
      is_save: 1,
      isC: true
    });
  }

  mapClose(sdata: any) {
    this.dialogRef.close(sdata)
  }

  Close() {
    this.dialogRef.close({
      isC: false
    })
  }

  current_datetime() {
    let now = new Date();
    let year = "" + now.getFullYear();
    let month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
    let day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
    let hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
    let minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
    let second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
    return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
  }
}